import React from 'react';

const BoookingProcess = {
  title: 'Booking Process',
  subTitle: [
    {
      title: 'Trip',
      items: [
        {
          header: 'What does the lightning symbol mean? / What is Instant Book?',
          content: (
            <div>
              <p>The lightning symbol indicates that the trip is available for instant booking. This means your Local Expert is available on your requested date and you could book the trip immediately. An automatic booking confirmation will be sent to your registered email after the payment is completed.</p>
            </div>
          )
        },
        {
          header: 'What is the next step after booking?',
          content: (
            <div>
              <p>After completing the payment, you will have to wait for your Local Expert’s confirmation of the requested date at least 24 hours before the trip date. If your booking is confirmed, a confirmation email with booking details and Local Expert’s personal contact information will be sent to your registered email address. </p>
            </div>
          )
        },
        {
          header: 'How can I know if my booking is confirmed?',
          content: (
            <div>
              <p>Your booking will be confirmed only after you complete your online payment and the Local Expert confirms your booking request. A confirmation email will be sent to your registered email address. </p>
              <p>Don’t worry, if you enter your credit card details but the Local Expert does not confirm your booking, the transaction will not be made.</p>
            </div>
          )
        },
        {
          header: 'What can I do if the Local Expert is not available on my requested date?',
          content: (
            <div>
              <p>We encourage you to discuss this directly with the Local Expert and see whether they are available on another date. </p>
              <p>If you and the Local Expert cannot come to an agreement, you can send us a request for a substitute Local Expert. We will do our best to find a substitute Local Expert to host the same trip with the same price for you. </p>
              <p>However, your payment must be completed before sending us a substitute Local Expert request. Please note that we may not be able to find a substitute Local Expert for you if the request is sent on short notice. </p>
              <p>Tip: If you enter your credit card details but the Local Expert does not confirm your booking, the transaction will not be made.</p>
            </div>
          )
        },
        {
          header: 'What if I can’t find my Local Expert when I arrive at the meeting point?',
          content: (
            <div>
              <p>After completing the payment, you will receive the Local Expert’s personal contact information. We suggest you contact the Local Expert using the given information or send them a message on TakeMeTour chat system in order to reconfirm the meeting point, time, and other details. </p>
              <p>On the trip date, if you still cannot reach or find your Local Expert, please contact our Support Team via WhatsApp or <a href="mailto:support@takemetour.com">support@takemetour.com</a> and we will do our best to assist you. If we cannot contact your Local Expert, we will cancel your booking and process a refund (booking fee included) for you.</p>
            </div>
          )
        },
        {
          header: 'How do I find a trip that matches my preferences?',
          content: (
            <div>
              <p>You can browse trips by province/city. On the search result page, you can also filter the results by price, number of guests, and activity that suits your preferences.</p>
            </div>
          )
        },
        {
          header: 'How do I book a trip?',
          content: (
            <div>
              <ul>
                <li>After finding a trip that you would like to join, please check the trip details, price conditions, and available dates on the calendar. </li>
                <li>You can send a message to the Local Expert for further inquiries about the trip by clicking “Ask Local Expert”. </li>
                <li>To book, please click ‘Book’ or ‘Instant Book’.
                The transaction will be made only after the Local Expert confirms your booking. The
                payment must be completed at least 24 hours before the trip date. Please note that if you complete the payment in less than the time frame stated, you might not be able to go on the trip on your requested date.
                </li>
                <li>Once your booking request is confirmed, a confirmation email with booking details and Local Expert’s personal contact information will be sent to your registered email address. </li>
              </ul>
            </div>
          )
        },
        {
          header: 'What are the differences between ‘Ask Local Expert’ and ‘Book’ or ‘Instant Book’?',
          content: (
            <div>
              <p>By clicking ‘Ask Local Expert’, you can ask questions and discuss available dates with the Local Expert before you decide to complete the payment. </p>
              <p>By clicking ‘Book’ or ‘Instant Book’, you can start booking the trip. In case of ‘Book’, you will need to wait for a manual booking confirmation from the Local Expert. In case of ‘Instant Book’, you will get an automatic confirmation email as the Local Expert is instantly available for the trip on your requested date. </p>
            </div>
          )
        },
        {
          header: 'How do I reschedule my trip date?',
          content: (
            <div>
              <p>TakeMeTour allows you to reschedule the trip date under several conditions. If your booking isn’t confirmed, you may select the new available date on the trip page. However, if you would like to reschedule the confirmed trip date, please notify both your Local Expert and us at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
            </div>
          )
        },
        {
          header: 'What is response rate?',
          content: (
            <div>
              <p>Response rate is the percentage of messages that are actually responded to by each Local Expert. The higher percentage, the faster the response from the Local Expert. </p>
            </div>
          )
        },
        {
          header: 'How do I contact a Local Expert?',
          content: (
            <div>
              <p>Even without completing the payment, you can send a message to a Local Expert and ask them for more trip details by clicking ‘Ask Local Expert’ on the right panel.</p>
              <p>However, until the payment is completed and the booking confirmed, you will not be able to exchange your personal contact information (e.g. phone number, email, social media account) with the Local Expert. If you send them your contact information, your message will be censored and banned by the system.</p>
              <p>Therefore, please feel free to contact a Local Expert using our chat system. You may proceed with the payment later and the transaction will be made only after the Local Expert confirms your booking. Then, a confirmation email with booking details and Local Expert’s personal contact information will be sent to your registered email address.</p>
            </div>
          )
        },
        {
          header: 'How do I know if a trip is available?',
          content: (
            <div>
              <p>You can check the available dates on the calendar on the trip page. You will notice lightning symbols, black trip dates, and grey trip dates. </p>
              <p>The lightning symbol signifies instant availability, which means you can select a trip date with the lightning symbol and book instantly without waiting for the Local Expert’s manual confirmation.</p>
              <p>The black trip date signifies availability upon request, which means can select a date and ask if the Local Expert is available on that date.</p>
              <p>The grey trip date signifies unavailability, which means it is impossible to go on the trip on the date.</p>
            </div>
          )
        }
      ]
    },
    {
      title: 'Ticket',
      items: [
        {
          header: 'How long does it take to receive a ticket?',
          content: (
            <div>
              <p>It depends on the conditions of each ticket. For some tickets, you will receive an e-ticket/voucher within 15 minutes after completing the payment. For other tickets, you might need to wait for a confirmation email, which will be sent to you within 12 hours after completing the payment. Please kindly check ticket conditions in each ticket detail page.</p>
            </div>
          )
        },
        {
          header: 'How can I know if my booking is confirmed? ',
          content: (
            <div>
              <p>After completing the payment, 2 emails will be sent to your registered email address. The first one is a confirmation email. The second one contains  e-ticket/voucher with QR code. Some tickets (e.g. tickets for shows or overseas attractions) might require you to wait for another confirmation within 12 hours.</p>
            </div>
          )
        },
        {
          header: 'What will I get after booking?',
          content: (
            <div>
              <p>Firstly, you will receive a confirmation email from TakeMeTour. Then a separate e-ticket/voucher with QR code will be sent to your registered email address.</p>
            </div>
          )
        },
        {
          header: 'What should I do If I didn’t receive the ticket? ',
          content: (
            <div>
              <p>This rarely happens, but if you don’t get an e-ticket/voucher email with QR code within 15 minutes after completing the payment, please send an email with your confirmation code to <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible.</p>
            </div>
          )
        },
        {
          header: 'How can I change my email address?',
          content: (
            <div>
              <p>After completing the payment, you can not change your registered email address by yourself.</p>
              <p>However, if you would like to receive your voucher with another email address, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible.</p>
            </div>
          )
        },
      ]
    },
    {
      title: 'Transfer',
      items: [
        {
          header: 'How can I know if my booking is confirmed?',
          content: (
            <div>
              <p>After completing the payment, a confirmation email will be sent to your registered email address within 15 minutes. </p>
            </div>
          )
        },
        {
          header: 'What will I get after booking?',
          content: (
            <div>
              <p>Firstly, you will receive a confirmation email from TakeMeTour. Please read the details carefully (e.g. meeting point, time, date, flight detail, and hotel name). If there is incorrect information, please email us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> at least 24 hours before the pickup time.</p>
            </div>
          )
        },
        {
          header: 'What should I do If I didn’t receive the confirmation email?',
          content: (
            <div>
              <p>This rarely happens, but if you don’t get a confirmation email within 15 minutes after completing the payment, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible.</p>
            </div>
          )
        },
        {
          header: 'How can I book a private transportation service?',
          content: (
            <div>
              <p>You can book a private transportation service through this <a href="https://www.takemetour.com/article/private-airport-transfers-van-car-rentals">link</a>. We also provide airport transfers and car/van rentals with personal driver. For airport transfers, we provide airport-hotel transfers and vice versa.</p>
              <p>After choosing your prefered type of transport and destination, please provide the necessary details (e.g. flight detail, hotel name, pickup date and time). Once the payment is completed, a confirmation email will be sent to your registered email address.</p>
              <p>Please note that that the transportation service should be made at least 24 hours in advance.</p>
            </div>
          )
        },
        {
          header: 'How can I change my email address?',
          content: (
            <div>
              <p>After completing the payment, you can not change your registered email address by yourself.</p>
              <p>However, if you would like to receive your voucher with another email address, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible.</p>
            </div>
          )
        },
      ]
    },
    {
      title: 'Souvenir',
      items: [
        {
          header: 'How will I receive the purchased item?',
          content: (
            <div>
              <p>After completing the payment, we will send the purchased item(s) to your provided address, based on your requested date. Any purchase can not be amended, exchanged, returned, or canceled under any circumstances. If your order is damaged or broken, please kindly contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a>  as soon as possible.</p>
            </div>
          )
        },
        {
          header: 'What should I do if I didn’t receive the purchased item?',
          content: (
            <div>
              <p>This rarely happens, but if your purchased item(s) didn’t arrive on your requested date, please kindly contact <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible. We will do our best to help you and make sure you receive it.</p>
            </div>
          )
        },
        {
          header: 'Where can I pick up the SIM card?',
          content: (
            <div>
              <p>It depends on which airport (Suvarnabhumi Airport/BKK or Don Mueang Airport/DMK) you choose. Click this <a href="https://www.takemetour.com/trip/happy-tourist-sim-card-8-days">link</a> for a pickup at Suvarnabhumi Airport and click this <a href="https://www.takemetour.com/trip/happy-tourist-sim-card-8-days-DMK">link</a> for a pickup at Don Mueang Airport. On these pages, you will also find instructions on how to pick up and activate the SIM card.</p>
            </div>
          )
        }
      ]
    }
  ]
};

export default BoookingProcess;
